import React from 'react';
import { Form as AntdForm } from 'antd';
import FormBase, { FormInstance, FormProps } from 'antd/lib/form';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

import theme from '~/constants/theme';
import colors from '~/constants/colors';
import FormItem from './FormItem';

const StyledForm = styled(AntdForm as any)`
  background-color: ${colors.componentBackground};
  border-radius: 20px;
  .ant-form-item {
    margin-bottom: ${theme.formVerticalSpacing}px;
  }
`;

interface IFormPropsWithChildren extends FormProps {
  children?: React.ReactNode;
}

type Props = React.FC<IFormPropsWithChildren> & {
  Item: typeof FormItem;
  List: typeof List;
  useForm: typeof useForm;
  Provider: typeof Provider;
};

const Form: Props = (props) => {
  const { form, onValuesChange, ...rest } = props;

  const resetAllErrors = (formInstance: FormInstance) => {
    const fieldsWithErrors = formInstance.getFieldsError().filter((item) => !isEmpty(item.errors));
    formInstance.setFields(fieldsWithErrors.map((item) => ({ name: item.name, errors: [] })));
  };

  const handleValuesChange = (changedValues: any, values: any) => {
    if (typeof onValuesChange === 'function') {
      onValuesChange(changedValues, values);
    }
    if (form) {
      resetAllErrors(form);
    }
  };

  return (
    <StyledForm
      form={form}
      validateTrigger="onBlur"
      onValuesChange={handleValuesChange}
      {...rest}
    />
  );
};

const { List, useForm, Provider } = AntdForm;

Form.Item = FormItem;
Form.List = List;
Form.useForm = useForm;
Form.Provider = Provider;

export default Form;
